angular.module('hjSurveysModule', ['hjApp.account', 'hjApp.storage', 'ui.router']);
